import { Link } from "react-router-dom";

/**
 * AI Accuracy Disclaimer + required acknowledgement checkbox.
 * Kept identical across signup, first-acceptance, and re-acceptance flows —
 * the wording is legal copy and must not drift between pages.
 */
export function AiAcknowledgement(props: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <div
      style={{
        marginBottom: "0.5rem",
        border: "1px solid #fbbf24",
        borderRadius: "0.75rem",
        padding: "0.85rem 1rem",
        backgroundColor: "#fffbeb",
      }}
    >
      <div style={{ fontWeight: 700, fontSize: "0.85rem", color: "#92400e", marginBottom: "0.35rem" }}>
        AI Accuracy Disclaimer
      </div>
      <div style={{ fontSize: "0.8rem", color: "#78350f", lineHeight: 1.5, marginBottom: "0.6rem" }}>
        SpeedyCore services use AI that can produce <strong>inaccurate, incomplete, outdated, or unsuitable
        output</strong>. AI output is <strong>not</strong> professional, legal, financial, engineering, safety,
        or compliance advice. You are responsible for checking everything AI generates before relying on it.
        See{" "}
        <Link to="/legal/terms" target="_blank" rel="noopener noreferrer" style={{ color: "#92400e", textDecoration: "underline" }}>
          Terms §7A
        </Link>
        .
      </div>
      <label style={{ display: "flex", gap: "0.5rem", alignItems: "flex-start", fontSize: "0.85rem", color: "#1f2937", cursor: "pointer", userSelect: "none" }}>
        <input
          type="checkbox"
          id="speedycore-ai-consent"
          name="speedycore_ai_consent"
          checked={props.checked}
          onChange={(e) => props.onChange(e.target.checked)}
          style={{ marginTop: "0.2rem", transform: "scale(1.05)" }}
          aria-describedby="speedycore-ai-text"
          required
        />
        <span id="speedycore-ai-text" style={{ lineHeight: 1.5 }}>
          I understand AI output may be wrong or incomplete, and I accept that{" "}
          <strong>I am responsible for checking and verifying all AI-generated work</strong>{" "}
          before relying on, publishing, or acting on it.
        </span>
      </label>
    </div>
  );
}
